/* Theme */
function hasThemeSetting(key) {
    const setting = localStorage.getItem(key)
    return !!setting
}

function setThemeSettings(key, value) {
    localStorage.setItem(key, value);
}

function removeDarkMode(html) {
    html.classList.remove('dark-mode')
    setThemeSettings('alto_dark', false)
}

function addDarkMode(html) {
    html.classList.add('dark-mode')
    setThemeSettings('alto_dark', true)
}

/* Events */
function addChangeThemeEvent () {
    const html = document.querySelector('html');
    const toggleTrack = document.querySelector('.toggle-track');

    toggleTrack.addEventListener("click", () => {
        const inDarkMode = html.classList.contains('dark-mode');
        inDarkMode ? removeDarkMode(html) : addDarkMode(html)
    })
}

function addFirstTimeViewEvent () {
    if (hasThemeSetting('first_time')) return;
    
    const html = document.querySelector('html');

    setThemeSettings('first_time', true)
    addDarkMode(html)
}

function addCarousel() {
    var carousel = $('.carousel');
    var postImage = carousel.find('.post-image');
    var imageHeight, nav;

    function moveNav() {
        imageHeight = postImage.height();
        if (!nav) {
            nav = carousel.find('.owl-prev, .owl-next');
        }
        nav.css({
            top: imageHeight / 2 + 'px',
            opacity: 1,
        });
    }

    carousel.owlCarousel({
        dots: false,
        margin: 28,
        nav: true,
        navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor"><path d="M20.547 22.107l-6.107-6.107 6.107-6.12-1.88-1.88-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor"><path d="M11.453 22.107l6.107-6.107-6.107-6.12 1.88-1.88 8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        onInitialized: function () {
            moveNav();
        },
        onResized: function () {
            moveNav();
        },
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
        },
    });
}

/* Initial */
$(function () {
    addFirstTimeViewEvent(); 
    addChangeThemeEvent();
    addCarousel();
});

